import * as React from "react";

const ChevronUp: React.FC = () => {
    return <svg width="12px" height="8px" viewBox="0 0 12 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="currentColor" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-331.000000, -363.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(252.000000, 131.000000)">
                    <polygon points="1.4 9.75 6 5.05 10.6 9.75 12 8.35 6 2.25 0 8.35"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(ChevronUp);
